var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M23.5,3h-20C3.2236328,3,3,3.2236328,3,3.5V6H0.5C0.2236328,6,0,6.2236328,0,6.5V19 c0,1.1030273,0.8974609,2,2,2h20c1.1025391,0,2-0.8969727,2-2V3.5C24,3.2236328,23.7763672,3,23.5,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E5",
    d: "M3,19c0,0.5512695-0.4482422,1-1,1s-1-0.4487305-1-1V7h2V19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#010101",
    d: "M2.00177,17.8104248c0.0001221,0.5897217-0.0279541,1.1795654-0.1114502,1.7633667 c-0.0175781,0.1229248-0.0313721,0.2578125-0.0401611,0.395874C1.901062,19.9776611,1.9468384,20,2,20c0.5517578,0,1-0.4487305,1-1 V7H2.0003662L2.00177,17.8104248z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M23,19c0,0.5512695-0.4482422,1-1,1H3.7314453C3.9023438,19.7055664,4,19.3637695,4,19V4h19V19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M5.5,11C5.7763672,11,6,10.7763672,6,10.5V7h0.5C6.7753906,7,7,7.2241211,7,7.5v3 C7,10.7763672,7.2236328,11,7.5,11S8,10.7763672,8,10.5v-3C8,6.6728516,7.3271484,6,6.5,6h-1C5.2236328,6,5,6.2236328,5,6.5v4 C5,10.7763672,5.2236328,11,5.5,11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M9.5,11h2c0.2763672,0,0.5-0.2236328,0.5-0.5S11.7763672,10,11.5,10H10V9h1 c0.2763672,0,0.5-0.2236328,0.5-0.5S11.2763672,8,11,8h-1V7h1.5C11.7763672,7,12,6.7763672,12,6.5S11.7763672,6,11.5,6h-2 C9.2236328,6,9,6.2236328,9,6.5v4C9,10.7763672,9.2236328,11,9.5,11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M14.0839844,10.7773438C14.1767578,10.9165039,14.3330078,11,14.5,11 s0.3232422-0.0834961,0.4160156-0.2226563L15.5,9.9013672l0.5839844,0.8759766C16.1767578,10.9165039,16.3330078,11,16.5,11 s0.3232422-0.0834961,0.4160156-0.2226563l1-1.5C17.9707031,9.1953125,18,9.0986328,18,9V6.5C18,6.2236328,17.7763672,6,17.5,6 S17,6.2236328,17,6.5v2.3486328l-0.5,0.75l-0.5-0.75V6.5C16,6.2236328,15.7763672,6,15.5,6S15,6.2236328,15,6.5v2.3486328 l-0.5,0.75l-0.5-0.75V6.5C14,6.2236328,13.7763672,6,13.5,6S13,6.2236328,13,6.5V9 c0,0.0986328,0.0292969,0.1953125,0.0839844,0.2773438L14.0839844,10.7773438z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M20.5,10h-1c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5h1 c0.8271484,0,1.5-0.6728516,1.5-1.5S21.3271484,8,20.5,8C20.2246094,8,20,7.7758789,20,7.5S20.2246094,7,20.5,7h1 C21.7763672,7,22,6.7763672,22,6.5S21.7763672,6,21.5,6h-1C19.6728516,6,19,6.6728516,19,7.5S19.6728516,9,20.5,9 C20.7753906,9,21,9.2241211,21,9.5S20.7753906,10,20.5,10z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M5.5,18h7c0.2763672,0,0.5-0.2236328,0.5-0.5v-5c0-0.2763672-0.2236328-0.5-0.5-0.5h-7 C5.2236328,12,5,12.2236328,5,12.5v5C5,17.7763672,5.2236328,18,5.5,18z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M21.5,13h-7c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5h7 c0.2763672,0,0.5-0.2236328,0.5-0.5S21.7763672,13,21.5,13z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M21.5,15h-7c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5h7 c0.2763672,0,0.5-0.2236328,0.5-0.5S21.7763672,15,21.5,15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#303C42",
    d: "M21.5,17h-7c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5h7 c0.2763672,0,0.5-0.2236328,0.5-0.5S21.7763672,17,21.5,17z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    fill: "#3D82C4",
    width: 6,
    height: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.0983438,
    y1: 6.1777954,
    x2: 24.8119392,
    y2: 17.7019348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M23.5,3h-20C3.2236328,3,3,3.2236328,3,3.5V6H0.5C0.2236328,6,0,6.2236328,0,6.5V19 c0,1.1030273,0.8974609,2,2,2h20c1.1025391,0,2-0.8969727,2-2V3.5C24,3.2236328,23.7763672,3,23.5,3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.754d57e1ab9a4a7e460f7f45579daf72.svg";
export { ForwardRef as ReactComponent };